var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description-dom",domProps:{"innerHTML":_vm._s(_vm.activityInfoData.description)}})
}
var staticRenderFns = []

export { render, staticRenderFns }